import { render, staticRenderFns } from "./PacklistItems.vue?vue&type=template&id=86f35c8e&scoped=true"
import script from "./PacklistItems.vue?vue&type=script&lang=js"
export * from "./PacklistItems.vue?vue&type=script&lang=js"
import style0 from "./PacklistItems.vue?vue&type=style&index=0&id=86f35c8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f35c8e",
  null
  
)

export default component.exports